import { gql } from '@provision/graphql-client';
import { CONVERSATION_MESSAGE_REACTION_FIELDS } from 'src/graphql/entities/conversation-message-reaction/conversation-message-reaction.operations';

export const CONVERSATION_MESSAGE_THREAD_FIELDS = gql`
  fragment ConversationMessageThreadFields on ConversationMessageThread {
    id
    conversationMessageThreadId
    conversationMessageId
    conversationId
    partnerId
    resolutionConversationMessageId
    resolvedByUserId
    resolvedAt
  }
`;

export const MESSAGE_REPLY_FIELDS = gql`
  fragment MessageReplyFields on ConversationMessage {
    id
    conversationMessageId
    conversationId
    partnerId
    parentConversationMessageId
    body
    createdAt
    editedAt
    deletedAt
    isPrivate
    senderChannel {
      id
      conversationParticipant {
        id
        participantIdentity
        participantEntity
        platformUser {
          id
          userId
          partnerId
          firstName
          lastName
          avatarFileKey
        }
      }
    }
  }
`;

/** A message's replies and the state of its thread. */
export const MESSAGE_THREAD_FRAGMENT = gql`
  fragment MessageThread on ConversationMessage {
    id
    replies {
      ...MessageReplyFields
      reactions {
        ...ConversationMessageReactionFields
      }
    }
    thread {
      ...ConversationMessageThreadFields
    }
  }
  ${MESSAGE_REPLY_FIELDS}
  ${CONVERSATION_MESSAGE_REACTION_FIELDS}
  ${CONVERSATION_MESSAGE_THREAD_FIELDS}
`;

export const GET_MESSAGE_THREAD_QUERY = gql`
  query GetMessageThread($params: QueryParamsWithSearch) {
    getConversationMessage(queryParams: $params) {
      records {
        ...MessageThread
      }
    }
  }
  ${MESSAGE_THREAD_FRAGMENT}
`;

export const RESOLVE_CONVERSATION_MESSAGE_THREAD_MUTATION = gql`
  mutation ResolveConversationMessageThread($params: ResolveConversationMessageThreadInput!) {
    resolveConversationMessageThread(params: $params) {
      ...ConversationMessageThreadFields
    }
  }
  ${CONVERSATION_MESSAGE_THREAD_FIELDS}
`;

export const UNRESOLVE_CONVERSATION_MESSAGE_THREAD_MUTATION = gql`
  mutation UnresolveConversationMessageThread(
    $params: UnresolveConversationMessageThreadInput!
  ) {
    unresolveConversationMessageThread(params: $params) {
      ...ConversationMessageThreadFields
    }
  }
  ${CONVERSATION_MESSAGE_THREAD_FIELDS}
`;
